import { useRef } from "react";
import "../styles/output.css";
import Button from "../components/basicComponents/button";
import TextInput from "../components/basicComponents/text-input";
import { useFormik } from "formik";
import { ReactComponent as PasswordIcon } from "../assets/SVGs/pass.svg";
import { ReactComponent as LoginSvg } from "../assets/SVGs/login-svg.svg";
import theme from "../config/theme";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../state-management/store";
import { changePasswordSchema } from "../utils/validation-schema";
import { editPassword } from "../state-management/actions/auth-actions";

import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const oldPasswordRef = useRef<any>(null);
  const newPasswordRef = useRef<any>(null);
  const confirmPasswordRef = useRef<any>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Get the current theme mode from the global state
  const themeMode = useSelector((state: RootState) => state.globalState.theme);
  const mode = themeMode === "light" ? theme.light : theme.dark;

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: changePasswordSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          oldPassword: values.oldPassword,
          newPassword: values.newPassword,
          confirmPassword: values.confirmPassword,
        };
        if (data.newPassword !== data.confirmPassword) {
          dispatch(setAlert(true));
          dispatch(setAlertSeverity("error"));
          dispatch(setAlertContext("رمز جدید و تاییدیه آن یکسان نمیباشد"));
        }
        if (data.oldPassword === data.newPassword) {
          dispatch(setAlert(true));
          dispatch(setAlertSeverity("error"));
          dispatch(setAlertContext("رمز جدید با رمز قبلی یکسان میباشد"));
        } else {
          const response = await editPassword(data)(dispatch);
          if (response.data) {
            dispatch(setAlert(true));
            dispatch(setAlertSeverity("success"));
            dispatch(setAlertContext("رمز جدید با موفقیت ثبت شد"));
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <div
      className="w-full min-h-screen flex flex-col items-center justify-center"
      style={{ backgroundColor: mode.backgroundColor.bgPrimary }}
    >
      <div className="grid md:grid-cols-2 items-center max-w-4xl max-md:max-w-lg w-full m-4 shadow-[0_2px_10px_-3px_rgba(128,128,128,0.3)] rounded-lg border border-[#0e9f6e3d]">
        <div
          className="md:h-full rounded-lg p-8 flex justify-center items-center hidden md:flex"
          style={{ backgroundColor: mode.backgroundColor.bgGray }}
        >
          <LoginSvg style={{ color: "green" }} />
        </div>
        <div className="md:max-w-full w-full md:p-14 p-5">
          <div className="p-2 flex flex-col items-center justify-center">
            <p
              className="text-xl font-bold my-2"
              style={{ color: mode.color.textPrimary }}
            >
              تغییر رمز!
            </p>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <TextInput
              ref={oldPasswordRef}
              name="oldPassword"
              label="رمز قبلی"
              placeholder="رمز قبلی را وارد کنید"
              RightIcon={<PasswordIcon />}
              onSubmit={() => newPasswordRef.current?.focus()}
              textAlign="left"
              value={formik.values.oldPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.oldPassword && formik.errors.oldPassword
                  ? formik.errors.oldPassword
                  : undefined
              }
            />
            <TextInput
              ref={newPasswordRef}
              name="newPassword"
              label="رمز جدید"
              placeholder="رمز جدید را وارد کنید"
              RightIcon={<PasswordIcon />}
              onSubmit={() => confirmPasswordRef.current?.focus()}
              textAlign="left"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.newPassword && formik.errors.newPassword
                  ? formik.errors.newPassword
                  : undefined
              }
            />
            <TextInput
              ref={confirmPasswordRef}
              name="confirmPassword"
              label="تکرار رمز جدید"
              placeholder="رمز جدید را تکرار کنید"
              RightIcon={<PasswordIcon />}
              onSubmit={() => buttonRef.current?.focus()}
              textAlign="left"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
                  ? formik.errors.confirmPassword
                  : undefined
              }
            />
            <Button
              ref={buttonRef}
              title="ثبت"
              type="submit"
              color="white"
              backgroundColor="#2D667F"
              paddingx="153px"
              paddingy="10px"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
